import React from 'react';
import EditorOrdered from '@wix/da-ds/pkg/Icons/24x24/EditorOrdered';
import { ButtonProps } from './types';
import { isExtensionInstalled } from '../../utils/tiptap';
import { useTranslation } from 'react-i18next';
import EditorIconButton from '../_partials/EditorIconButton';

const OrderedList: React.FC<ButtonProps> = ({
  editor,
  hideWhenNotEnabled = true,
}) => {
  const { t } = useTranslation('editor');

  if (
    !editor.isEditable ||
    (hideWhenNotEnabled && !isExtensionInstalled(editor, 'orderedList'))
  ) {
    return null;
  }

  if (editor.isActive('bulletList')) {
    return (
      <EditorIconButton
        featureId="format:orderedList"
        icon={EditorOrdered}
        onClick={() => {
          editor
            .chain()
            .focus()
            .toggleList('orderedList', 'listItem', true)
            .run();
        }}
        isActive={editor.isActive('orderedList')}
        tooltipText={t('button.ordered.tooltip')}
        aria-label={t('button.ordered.tooltip')}
      />
    );
  }

  return (
    <EditorIconButton
      featureId="format:orderedList"
      icon={EditorOrdered}
      disabled={!editor.can().chain().focus().toggleOrderedList().run()}
      onClick={() => editor.chain().focus().toggleOrderedList().run()}
      isActive={editor.isActive('orderedList')}
      tooltipText={t('button.ordered.tooltip')}
      aria-label={t('button.ordered.tooltip')}
    />
  );
};
OrderedList.displayName = 'OrderedList';

export default OrderedList;
